import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor", opacity: 0.2 }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.696 9.955a7 7 0 0 1-9.329 8.533l-.147-.059-.01-.003h-.003l-.128.02-2.49.416-.02.003c-.113.019-.239.04-.348.048a1.1 1.1 0 0 1-.51-.074 1.05 1.05 0 0 1-.55-.55 1.1 1.1 0 0 1-.074-.51c.008-.11.03-.235.048-.347l.003-.02.415-2.49c.012-.068.018-.103.021-.13v-.002l-.003-.01-.059-.147a7 7 0 0 1 7.012-9.613c-.24.418-.405.884-.48 1.38H12a5.6 5.6 0 0 0-5.19 7.706l.012.031c.043.105.094.23.12.346.023.105.034.197.034.306 0 .118-.02.238-.037.335l-.005.027-.382 2.297 2.297-.383.027-.004c.097-.016.217-.037.335-.037.109 0 .2.01.306.034.117.026.241.077.346.12l.031.013a5.6 5.6 0 0 0 7.56-6.464 4 4 0 0 0 1.242-.772M9.2 9.55a.7.7 0 1 0 0 1.4H12a.7.7 0 1 0 0-1.4zm0 2.45a.7.7 0 1 0 0 1.4h4.9a.7.7 0 1 0 0-1.4z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 7, r: 2, fill: "#FF5C39" })
);
var SvgCircledMessageNewOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledMessageNewOutlined_default = SvgCircledMessageNewOutlined;

export { CircledMessageNewOutlined_default as default };
